<template>
    <div class="ml-4">
        <tooltip
            v-if="boosterInfo"
            :content="boosterInfo.message"
            position="right">
            <span :class="boosterInfo.published ? 'text-secondary' : 'text-semantic-error'">
                 <svg-icon type="rocket-launch" size="18"></svg-icon>
            </span>
        </tooltip>
    </div>
</template>

<script>
import Tooltip from "./navigation/Tooltip.vue";
import {mapState} from "pinia";
import {useMainStore} from '../state/store';
import moment from "moment";
import SvgIcon from './ui/SvgIcon.vue';

export default {
    name: "BoosterInfo",
    components: {
        Tooltip,
        SvgIcon
    },
    props: {
        booster: Object,
    },
    computed: {
        ...mapState(useMainStore, ['locale', 'dateFormat']),
        boosterInfo() {
            const requested = this.parseDate(this.booster.requested_at);
            const published = this.parseDate(this.booster.published_at);
            const expires = this.parseDate(this.booster.expires_at);

            if (expires && (moment().diff(moment(this.booster.expires_at)) > 0)) {
                return null;
            }

            let message = this.booster.title;
            if (!published) {
                message += `: ${this.$t('boosters.requested')} ${requested}`;
            } else {
                message += `: ${this.$t('boosters.published_from_until', {
                    publish_date: published,
                    expires_date: expires,
                })}`;
            }

            return {
                published,
                message
            };
        }
    },
    methods: {
        parseDate(date) {
            if (!date) {
                return null;
            }

            return moment(date).locale(this.locale).format(this.dateFormat);
        }
    }
}
</script>

<style scoped>

</style>
